/* CVC Direct — quick order grid, saved lists, shareable links. */
(function () {
  var root = document.getElementById('cvc-qo-root');
  if (!root) return;

  var SUGGEST = root.dataset.suggest;
  var CART    = root.dataset.cart;
  var ADD     = root.dataset.add;
  var PAGE    = root.dataset.page || (location.origin + location.pathname);
  var DEBUG   = /[?&]cvcdebug/.test(location.search);
  var KEY     = 'cvcDirectLists';
  var rowsEl  = document.getElementById('cvc-qo-rows');
  var seq = 0;

  function log(){ if (DEBUG) console.log.apply(console, ['[quick order]'].concat([].slice.call(arguments))); }
  function money(p){ return '\u00a3' + (p/100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ','); }
  function norm(s){ return String(s || '').toLowerCase().replace(/[^a-z0-9]/g, ''); }
  function esc(s){ return String(s).replace(/[&<>"]/g, function(c){ return { '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;' }[c]; }); }

  function toast(m){
    var t = document.getElementById('cvc-co-toast'), x = document.getElementById('cvc-co-toast-text');
    if (!t) return;
    x.textContent = m; t.classList.add('is-on');
    clearTimeout(t._h); t._h = setTimeout(function(){ t.classList.remove('is-on'); }, 3200);
  }

  function refreshHeader(){
    fetch(CART, { headers: { 'Accept': 'application/json' } })
      .then(function(r){ return r.json(); })
      .then(function(c){
        var t = document.querySelector('.cvc-hd-total');
        if (t) t.textContent = money(c.total_price);
        var w = document.querySelector('.cvc-hd-cart');
        if (!w) return;
        var b = w.querySelector('.cvc-hd-count');
        if (c.item_count > 0) {
          if (!b) { b = document.createElement('span'); b.className = 'cvc-hd-count'; w.insertBefore(b, w.firstChild); }
          b.textContent = c.item_count;
        } else if (b) { b.remove(); }
      }).catch(function(){});
  }

  /* ---------- search ---------- */
  var cache = {}, pcache = {};

  function productUrl(p){
    var u = p && (p.url || (p.handle ? '/products/' + p.handle : ''));
    if (!u) return '';
    u = String(u).split('?')[0].split('#')[0];
    if (u.indexOf('/products/') === -1) return '';
    return u.replace(/\/$/, '') + '.js';
  }

  function fetchProduct(p){
    var u = productUrl(p);
    if (!u) return Promise.resolve(null);
    if (pcache[u]) return Promise.resolve(pcache[u]);
    return fetch(u, { headers: { 'Accept': 'application/json' } })
      .then(function(r){ return r.ok ? r.json() : null; })
      .then(function(d){ pcache[u] = d; return d; })
      .catch(function(){ return null; });
  }

  function variantsFrom(full, sug){
    var src = (full && full.variants && full.variants.length) ? full : sug;
    if (!src || !src.variants || !src.variants.length) return [];
    var title = (full && full.title) || sug.title || '';
    var img = (full && full.featured_image) || (sug.featured_image && sug.featured_image.url) || sug.image || '';
    var multi = src.variants.length > 1;
    return src.variants.map(function(v){
      var price = typeof v.price === 'number' ? v.price : Math.round(parseFloat(v.price) * 100);
      return {
        id: v.id,
        sku: v.sku || '',
        title: title + (multi && v.title && v.title !== 'Default Title' ? ' \u2014 ' + v.title : ''),
        price: isNaN(price) ? 0 : price,
        img: (v.featured_image && v.featured_image.url) || img,
        ok: v.available !== false
      };
    });
  }

  function search(q){
    var key = q.toLowerCase();
    if (cache[key]) return Promise.resolve(cache[key]);
    var url = SUGGEST + '?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=8';
    log('searching', url);
    return fetch(url, { headers: { 'Accept': 'application/json' } })
      .then(function(r){ return r.ok ? r.json() : null; })
      .then(function(d){
        var ps = (d && d.resources && d.resources.results && d.resources.results.products) || [];
        log('suggest returned', ps.length, ps[0]);
        if (!ps.length) return [];
        return Promise.all(ps.map(function(p){
          return fetchProduct(p).then(function(full){ return variantsFrom(full, p); });
        })).then(function(groups){
          var out = [];
          groups.forEach(function(g){ g.forEach(function(v){ out.push(v); }); });
          log('built', out.length, 'variants');
          return out;
        });
      })
      .then(function(out){
        var want = norm(q);
        out.sort(function(a, b){
          var ra = norm(a.sku) === want ? 0 : (norm(a.sku).indexOf(want) === 0 ? 1 : 2);
          var rb = norm(b.sku) === want ? 0 : (norm(b.sku).indexOf(want) === 0 ? 1 : 2);
          return ra - rb;
        });
        cache[key] = out;
        return out;
      })
      .catch(function(e){ log('failed', e); return []; });
  }

  /* ---------- rows ---------- */
  function addRow(prefill){
    var el = document.createElement('div');
    el.className = 'cvc-qo-row';
    el.dataset.id = 'r' + (++seq);
    el.innerHTML =
      '<div class="cvc-qo-find">' +
        '<input type="text" placeholder="Part number, product name or description" autocomplete="off" data-find>' +
        '<span class="cvc-qo-picked" data-picked hidden></span>' +
        '<div class="cvc-qo-sugg" data-sugg></div>' +
      '</div>' +
      '<input type="number" min="1" value="' + ((prefill && prefill.qty) || 1) + '" data-qty aria-label="Quantity">' +
      '<span class="cvc-qo-cell unit" data-unit>\u2014</span>' +
      '<span class="cvc-qo-cell line" data-line>\u2014</span>' +
      '<button type="button" class="cvc-qo-x" data-x aria-label="Remove line">&times;</button>';
    rowsEl.appendChild(el);
    if (prefill && prefill.text) {
      el.querySelector('[data-find]').value = prefill.text;
      resolveExact(el, prefill.text);
    }
    return el;
  }

  function setPicked(row, item){
    row._item = item;
    row.classList.remove('is-bad'); row.classList.add('is-ok');
    row.querySelector('[data-find]').value = item.title;
    var p = row.querySelector('[data-picked]');
    p.hidden = false; p.textContent = item.sku || '';
    recalc();
  }

  function setBad(row){
    row._item = null;
    row.classList.remove('is-ok'); row.classList.add('is-bad');
    row.querySelector('[data-picked]').hidden = true;
    recalc();
  }

  function resolveExact(row, text){
    search(text).then(function(res){
      var want = norm(text), hit = null;
      res.forEach(function(r){ if (!hit && norm(r.sku) === want) hit = r; });
      if (!hit && res.length === 1) hit = res[0];
      if (hit) setPicked(row, hit); else setBad(row);
    });
  }

  function recalc(){
    var lines = 0, total = 0;
    rowsEl.querySelectorAll('.cvc-qo-row').forEach(function(row){
      var qty = parseInt(row.querySelector('[data-qty]').value || '1', 10);
      if (qty < 1) qty = 1;
      if (row._item) {
        lines++;
        var lt = row._item.price * qty; total += lt;
        row.querySelector('[data-unit]').textContent = money(row._item.price);
        row.querySelector('[data-line]').textContent = money(lt);
      } else {
        row.querySelector('[data-unit]').textContent = '\u2014';
        row.querySelector('[data-line]').textContent = '\u2014';
      }
    });
    document.getElementById('cvc-qo-total').textContent =
      lines + ' line' + (lines === 1 ? '' : 's') + ' \u00b7 ' + money(total);
  }

  /* ---------- suggestions ---------- */
  var timer;
  rowsEl.addEventListener('input', function(e){
    var row = e.target.closest('.cvc-qo-row'); if (!row) return;
    if (e.target.matches('[data-qty]')) { recalc(); return; }
    if (!e.target.matches('[data-find]')) return;
    var q = e.target.value.trim();
    var box = row.querySelector('[data-sugg]');
    row._item = null; row.classList.remove('is-ok', 'is-bad');
    row.querySelector('[data-picked]').hidden = true;
    recalc();
    clearTimeout(timer);
    if (q.length < 2) { box.classList.remove('is-open'); box.innerHTML = ''; return; }
    box.innerHTML = '<div class="cvc-qo-s">Searching\u2026</div>';
    box.classList.add('is-open');
    timer = setTimeout(function(){
      search(q).then(function(res){
        if (!res.length) {
          box.innerHTML = '<div class="cvc-qo-s">No match \u2014 try part of the product name</div>';
          box.classList.add('is-open'); return;
        }
        box.innerHTML = res.slice(0, 12).map(function(r, i){
          return '<div class="cvc-qo-s" data-i="' + i + '">' +
            (r.img ? '<img src="' + r.img + '" alt="">' : '') +
            '<span class="cvc-qo-s-t">' + esc(r.title) +
            '<span class="cvc-qo-s-k">' + esc(r.sku || '') + (r.ok ? '' : ' \u00b7 unavailable') + '</span></span>' +
            '<span class="cvc-qo-s-p">' + money(r.price) + '</span></div>';
        }).join('');
        box._res = res;
        box.classList.add('is-open');
      });
    }, 200);
  });

  rowsEl.addEventListener('click', function(e){
    var s = e.target.closest('.cvc-qo-s');
    if (s && s.dataset.i !== undefined) {
      var box = s.parentNode, row = s.closest('.cvc-qo-row');
      var item = box._res && box._res[+s.dataset.i];
      if (item) { setPicked(row, item); box.classList.remove('is-open'); }
      return;
    }
    if (e.target.closest('[data-x]')) {
      e.target.closest('.cvc-qo-row').remove();
      if (!rowsEl.children.length) addRow();
      recalc();
    }
  });

  document.addEventListener('click', function(e){
    if (!e.target.closest('.cvc-qo-find')) {
      rowsEl.querySelectorAll('[data-sugg]').forEach(function(b){ b.classList.remove('is-open'); });
    }
  });

  rowsEl.addEventListener('keydown', function(e){
    if (e.key === 'Escape') {
      var r0 = e.target.closest('.cvc-qo-row');
      if (r0) r0.querySelector('[data-sugg]').classList.remove('is-open');
      return;
    }
    if (e.key !== 'Enter') return;
    e.preventDefault();
    var row = e.target.closest('.cvc-qo-row'); if (!row) return;
    var box = row.querySelector('[data-sugg]');
    if (box.classList.contains('is-open') && box._res && box._res.length) {
      setPicked(row, box._res[0]); box.classList.remove('is-open');
      var q = row.querySelector('[data-qty]'); q.focus(); q.select();
      return;
    }
    var next = row.nextElementSibling || addRow();
    next.querySelector('[data-find]').focus();
  });

  /* ---------- buttons ---------- */
  document.getElementById('cvc-qo-addrow').addEventListener('click', function(){
    addRow().querySelector('[data-find]').focus();
  });
  document.getElementById('cvc-qo-clear').addEventListener('click', function(){
    rowsEl.innerHTML = ''; addRow(); recalc();
    history.replaceState(null, '', location.pathname);
  });

  function collect(){
    var items = [];
    rowsEl.querySelectorAll('.cvc-qo-row').forEach(function(row){
      if (!row._item) return;
      var qty = parseInt(row.querySelector('[data-qty]').value || '1', 10);
      items.push({ id: row._item.id, quantity: qty < 1 ? 1 : qty, sku: row._item.sku });
    });
    return items;
  }

  document.getElementById('cvc-qo-add').addEventListener('click', function(){
    var items = collect();
    if (!items.length) { toast('Add at least one line first'); return; }
    var b = this; b.disabled = true; b.textContent = 'Adding\u2026';
    fetch(ADD, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items.map(function(i){ return { id: i.id, quantity: i.quantity }; }) })
    })
      .then(function(r){ return r.json().then(function(d){ return { ok: r.ok, d: d }; }); })
      .then(function(res){
        if (!res.ok) throw new Error(res.d.description || 'Could not add');
        var n = 0; (res.d.items || []).forEach(function(i){ n += i.quantity; });
        toast(n + ' item' + (n === 1 ? '' : 's') + ' added to your basket');
        refreshHeader();
      })
      .catch(function(err){ toast(err.message || 'Could not add to basket'); })
      .then(function(){ b.disabled = false; b.textContent = 'Add all to basket'; });
  });

  /* ---------- share links ----------
     The list travels in the URL, so nothing is stored server side and the
     recipient sees the list priced at whatever rate they are signed in to. */
  function encodeList(items){
    return items.map(function(i){
      return encodeURIComponent(i.sku || '') + ':' + i.quantity;
    }).join(',');
  }

  function decodeList(s){
    return String(s).split(',').map(function(pair){
      var bits = pair.split(':');
      var sku = decodeURIComponent(bits[0] || '').trim();
      var qty = parseInt(bits[1] || '1', 10);
      return sku ? { sku: sku, qty: qty > 0 ? qty : 1 } : null;
    }).filter(Boolean);
  }

  function shareUrl(items, name){
    var u = PAGE + '?l=' + encodeList(items);
    if (name) u += '&n=' + encodeURIComponent(name);
    return u;
  }

  var shareModal = document.getElementById('cvc-qo-sharemodal');
  var shareName  = document.getElementById('cvc-qo-sharename');
  var shareLink  = document.getElementById('cvc-qo-sharelink');
  var shareEmail = document.getElementById('cvc-qo-shareemail');
  var shareItems = [];

  function refreshShare(){
    var url = shareUrl(shareItems, shareName.value.trim());
    shareLink.value = url;
    var subject = shareName.value.trim() ? 'CVC Direct \u2014 ' + shareName.value.trim() : 'CVC Direct parts list';
    shareEmail.href = 'mailto:?subject=' + encodeURIComponent(subject) +
      '&body=' + encodeURIComponent('Here is the parts list:\n\n' + url + '\n\nOpen the link and everything is ready to add to a basket.');
  }

  function openShare(items, name){
    if (!items.length) { toast('Add at least one line first'); return; }
    shareItems = items;
    shareName.value = name || '';
    refreshShare();
    shareModal.hidden = false;
  }

  document.getElementById('cvc-qo-share').addEventListener('click', function(){ openShare(collect(), ''); });
  shareName.addEventListener('input', refreshShare);
  document.getElementById('cvc-qo-sharecancel').addEventListener('click', function(){ shareModal.hidden = true; });
  shareModal.addEventListener('click', function(e){ if (e.target === shareModal) shareModal.hidden = true; });

  document.getElementById('cvc-qo-sharecopy').addEventListener('click', function(){
    var v = shareLink.value;
    function done(){ toast('Link copied'); shareModal.hidden = true; }
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(v).then(done).catch(function(){ shareLink.select(); document.execCommand('copy'); done(); });
    } else { shareLink.select(); document.execCommand('copy'); done(); }
  });

  /* ---------- saved lists ---------- */
  function load(){ try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch(e){ return []; } }
  function store(l){ try { localStorage.setItem(KEY, JSON.stringify(l)); } catch(e){ toast('Your browser is blocking storage, so lists cannot be saved'); } }

  function renderLists(){
    var wrap = document.getElementById('cvc-qo-lists');
    var lists = load();
    if (!lists.length) {
      wrap.innerHTML = '<p class="cvc-qo-empty">No saved lists yet. Build one on the left and press Save as list.</p>';
      return;
    }
    wrap.innerHTML = lists.map(function(l, i){
      var n = l.items.reduce(function(a, b){ return a + b.qty; }, 0);
      return '<div class="cvc-qo-list"><div class="cvc-qo-listtop"><div>' +
        '<div class="cvc-qo-listname">' + esc(l.name) + '</div>' +
        '<div class="cvc-qo-listmeta">' + l.items.length + ' line' + (l.items.length === 1 ? '' : 's') + ' \u00b7 ' + n + ' item' + (n === 1 ? '' : 's') + '</div>' +
        '</div><div class="cvc-qo-actions" style="margin-top:0">' +
        '<button type="button" class="cvc-qo-btn small" data-load="' + i + '">Load</button>' +
        '<button type="button" class="cvc-qo-btn ghost small" data-share="' + i + '">Share</button>' +
        '<button type="button" class="cvc-qo-btn ghost small" data-del="' + i + '">Delete</button>' +
        '</div></div></div>';
    }).join('');
  }

  document.getElementById('cvc-qo-save').addEventListener('click', function(){
    var items = collect();
    if (!items.length) { toast('Nothing to save yet'); return; }
    var name = prompt('Name this list', document.getElementById('cvc-qo-title').dataset.listname || 'My list');
    if (!name) return;
    var lists = load();
    lists.push({ name: name, at: Date.now(), items: items.map(function(i){ return { sku: i.sku, qty: i.quantity }; }) });
    store(lists); renderLists(); toast('List saved');
  });

  document.addEventListener('click', function(e){
    var l = e.target.closest('[data-load]'), d = e.target.closest('[data-del]'), s = e.target.closest('[data-share]');
    if (!l && !d && !s) return;
    var lists = load();
    if (l) {
      var li = lists[+l.getAttribute('data-load')]; if (!li) return;
      rowsEl.innerHTML = '';
      li.items.forEach(function(it){ addRow({ text: it.sku, qty: it.qty }); });
      recalc(); toast('List loaded');
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
    if (s) {
      var ls = lists[+s.getAttribute('data-share')]; if (!ls) return;
      openShare(ls.items.map(function(i){ return { sku: i.sku, quantity: i.qty }; }), ls.name);
    }
    if (d) {
      if (!confirm('Delete this list?')) return;
      lists.splice(+d.getAttribute('data-del'), 1); store(lists); renderLists();
    }
  });

  /* ---------- paste ---------- */
  var modal = document.getElementById('cvc-qo-modal');
  document.getElementById('cvc-qo-paste').addEventListener('click', function(){ modal.hidden = false; });
  document.getElementById('cvc-qo-pastecancel').addEventListener('click', function(){ modal.hidden = true; });
  modal.addEventListener('click', function(e){ if (e.target === modal) modal.hidden = true; });
  document.addEventListener('keydown', function(e){
    if (e.key === 'Escape') { modal.hidden = true; shareModal.hidden = true; }
  });

  document.getElementById('cvc-qo-pasteadd').addEventListener('click', function(){
    var box = document.getElementById('cvc-qo-pastebox');
    box.value.split(/\r?\n/).forEach(function(line){
      var t = line.trim(); if (!t) return;
      var m = t.match(/^(.*?)[\s,;xX*]+(\d+)\s*$/);
      addRow({ text: m ? m[1].trim() : t, qty: m ? parseInt(m[2], 10) : 1 });
    });
    modal.hidden = true; box.value = '';
  });

  /* ---------- open from a shared link ---------- */
  function fromUrl(){
    var qs = new URLSearchParams(location.search);
    var l = qs.get('l');
    if (!l) return false;
    var name = qs.get('n');
    var items = decodeList(l);
    if (!items.length) return false;

    if (name) {
      var h = document.getElementById('cvc-qo-title');
      h.dataset.listname = name;
      var badge = document.createElement('span');
      badge.className = 'cvc-qo-shared';
      badge.textContent = 'Shared list \u00b7 ' + name;
      h.parentNode.insertBefore(badge, h);
      var intro = document.getElementById('cvc-qo-introtext');
      if (intro) intro.textContent = 'Someone has sent you this parts list. Check the quantities, then add the lot to your basket. You can change anything before you order.';
    }
    items.forEach(function(it){ addRow({ text: it.sku, qty: it.qty }); });
    return true;
  }

  if (!fromUrl()) addRow();
  renderLists();
  recalc();
  log('ready. suggest =', SUGGEST, 'page =', PAGE);
})();
